import controller from '../controllers/NotificationsCtrl';
import template from '../templates/notifications.html';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {},
};
